<template>
	<section class="container mt-md-4 mt-3 mb-3 mb-md-5 item-list-compo">
		<div v-if="isProduct" class="row item-list-category pt-5 pb-3 mx-2">
			<div class="col-6">
				<span><i class="far fa-bookmark" aria-hidden="true"></i>category</span><br>
				<select class="w-100" name="select1" @change="pagemove" v-model="category">
					<option value="0" name="all">すべて</option>
					<option v-for="category in cList" :key="category.index" :value="category.category_classname" name="">{{category.category_displayname}}</option>
				</select>
			</div>
			<div class="col-6">
				<span><i class="far fa-bookmark" aria-hidden="true"></i>artist</span><br>
				<select class="w-100" name="select2" @change="pagemove" v-model="artist">
					<option value="0" name="all">すべて</option>
					<option v-for="artist in aList" :key="artist.index" :value="artist.category_classname" name="">{{artist.category_displayname}}</option>
				</select>
			</div>
		</div>
		<nav v-if="isTop" aria-label="breadcrumb" role="navigation" class="mx-auto">
			<ol class="breadcrumb">
				<li class="breadcrumb-item" aria-current="page" itemscope="itemscope" itemtype="http://data-vocabulary.org/Breadcrumb">
				<span itemprop="title" class="text font-weight-bold">Pick Up</span>
				</li>
			</ol>
		</nav>
<!-- 		<slick v-if="isTop" ref="slick" :options="slickOptions" class="card-deck mx-3">
			<div v-for="item in disList.slice(minSlice,minSlice+perPage)" :key="item.index" @click="toDetail(item.Hin)" class="canClick card text-left opacity fadeIn animated topProSlide square clearfix">
				<img class="card-img-top" :src="host+item.ImgList[0].img_url" />
				<div class="card-body">
					<span class="stocks" :class="judgeStatus(item.StockStatus, item.Release)"></span>
					<span class="card-title main-point-color d-block">{{item.Title}}</span>
					<span class="card-text d-block">{{item.NetPrice}}円<small>（税込）</small></span>
				</div>
			</div>
		</slick> -->
		<div class="row mt-1" :class="mediaChk('pad')">
			<div class="card-deck col-12" :class="fadeapp ? 'appear':'vanish'">
				<div v-for="item in disList.slice(minSlice,minSlice+perPage)" :key="item.index" @click="toDetail(item.Hin)" class="canClick card text-left opacity fadeIn animated square col-6 col-sm-4">
					<img class="card-img-top" :src="host+item.ImgList[0].img_url" />
					<div class="card-body">
						<span class="stocks" :class="judgeStatus(item.StockStatus,item.variation_list, item.Release)"></span>
						<span class="card-title main-point-color d-block">{{item.Title}}</span>
						<span class="card-text d-block">{{item.NetPrice | addcomma}}円<small>（税込）</small></span>
					</div>
				</div>
			</div>
		</div>

		<div class="row" v-if="isProduct">
			<nav class="nav_pagination mx-auto mt-5" aria-label="ページネーション" :class="isVisible ? '':'visible'">
				<ul class="pagination justify-content-center">
					<li class="page-item" :class="isFirst ? 'cantClick':'canClick'" @click="preClick()">
						<a class="page-link" aria-label="前へ">
							<span aria-hidden="true" class="pre">«</span>
						</a>
					</li>
					<li v-if="(lastPage>5)&&(curPage>4)" class="cantClick page-link px-3 my-2 mx-1 pc-paging"><a><span>…</span></a></li>
					<template v-for="page of lastPage">
						<li class="page-link page-box px-3 my-2 mx-1 canClick pc-paging" :class="activeNum(page)" v-if="page>(Number(curPage)-4) && page<(Number(curPage)+4)" :key="page.index" @click="pageClick(page)">
							<a><span>{{page}}</span></a>
						</li>
					</template> 
					<li v-if="(lastPage>5)&&(curPage<(lastPage-3))" class="cantClick page-link px-3 my-2 mx-1 pc-paging"><a><span>…</span></a></li>
					<li class="page-item" @click="nextClick()" :class="isLast ? 'cantClick' : 'canClick'">
						<a class="page-link" aria-label="次へ">
							<span aria-hidden="true" class="next">»</span>
						</a>
					</li>
				</ul>
			</nav>
		</div>
	</section>
</template>

<style>
	.stocks{
		border-radius: 7px;
		padding: 5px 8px;
		display: flex;
		width: fit-content;
		margin: -0.5rem 0 0.3rem
	}
	.soldout{
		background-color: #000000;
		color: #fff;
	}
	.soldout::after{
		content: "SOLD OUT";
		font-size: 0.7rem;
	}
	.exist{
		background-color: #FF9BA6;
		color: #fff;
	}
	.exist::after{
		content: "在庫あり";
		font-size: 0.7rem;
	}
	.reserve{
		background-color: #82D7DA;
		color: #fff;
	}
	.reserve::after{
		content: "予約商品";
		font-size: 0.7rem;
	}
	.topProSlide img{
		width: 100% !important;
	}
	.square img{
		/*width: auto;*/
		/*max-height: 260px;*/
		overflow: hidden;
		object-fit: cover;
	}
	.active{
		background-color: #AAAAAA;
	}
	@media (max-width: 1024px){
		.square img{
			/*max-height: 260px;*/
		}
		.topProSlide img{
			max-height: 260px;
		}
	}@media (max-width: 768px){
		.square img{
			/*max-height: 190px;*/
		}
		.topProSlide img{
			max-height: 190px;
		}
		.stocks{
			border-radius: 5px;
			padding: 2px 5px;
			display: flex;
			width: fit-content;
			margin: -0.8rem -8px 0.3rem
		}
	}
	@media (max-width: 480px){
		.square img{
			/*max-height: 160px;*/
		}
		.topProSlide img{
			max-height: 160px;
		}
/*		.card span{
			font-size: 15px
		}*/
	}
	.appear{
		opacity: 1;
		transition: all .4s 0s ease;
	}
	.vanish{
		opacity: 0;
		transition: all .1s 0s ease;
	}
	.visible{
		display: none;
	}
	.page-box{
		border: 1.4px solid #AAAAAA;
		border-radius: 2px;
		text-align: center;
		align-items: center;
		display: flex;
		min-width: fit-content;
	}
	.page-box:hover{
		border: 1px solid #DDDDDD;
	}
	.page-box span:hover{
		color: #AAAAAA;
	}
	@media only screen and (max-width: 767px){
		.pc-paging{
			display: none;
		}
		.pre::after{
			content: " 前へ";
		}
		.next::before{
			content: "次へ "
		}
		.page-item{
			border: 1.4px solid #AAAAAA;
			border-radius: 5px;
			margin: 0 3vw;
		}
		.page-item:first-child .page-link{
			margin-left: 10px;
		}
	}
</style>

<script>
// import slick from 'vue-slick'
// import {gVar} from 'vuex'
// import cSelect from './category.vue'
export default{
	data(){
		return{
			host:process.env.VUE_APP_IAM,
			path:this.$route.path,
			num:Number,
			query:this.$route.query,
			category:'0',
			artist:'0',
			stock:'',
			nowYear:new Date().getFullYear(),
			nowMonth:String(new Date().getMonth()+1),
			nowDay:String(new Date().getDate()),
			nowHour:new Date().getHours(),
			nowMinutes:new Date().getMinutes(),
			isTop:false,
			isProduct:false,
			media:window.innerWidth, 
			minSlice:Number,
			perPage:Number,
			curPage:Number,
			lastPage:Number,
			selectPage:Number,
			pList:[],
			disList:[],
			cList:[],
			aList:[],
			fadeapp:true,
			isVisible:true,
			isFirst:false,
			// slickOptions:{
			// 	slidesToShow: 3,
			// 	arrows: true,
			// 	infinite: false,
			// },
		}
	},
	components:{
		// 'slick': slick,
	},
	created(){
		this.chkPath()
		this.getCategory()
		this.getJson()
	},
	methods:{
		async getJson(){
			await this.$axios
			.get(this.$uri)
			.then((response) => {
				if(response.data.is_maintenance == true){
					window.location.href="/maintenance/maintenance.html"
				}else{
/*					let now = String(this.nowYear)+String(this.nowMonth)+String(this.nowDay)
					let k = 0
					let del = []*/
					this.pList = response.data.product_list
					/*for(var i=0; i<this.pList.length; i++){
						console.log(this.pList[i].DisplayFrom)
						if(this.pList[i].DisplayFrom>now || this.pList[i].DisplayTo<now){
							console.log(this.pList[i])
							del[k]=i
							k++
						}
					}
					del.sort(function(a,b){
						if(a>b){return -1}
						if(a<b){return 1}
						return 0
					})
					for(var l=0; l<del.length; l++){
						this.pList.splice(del[i],1)
					}*/
					this.cList = response.data.category_master
					this.aList = response.data.artists_master
					this.sortOption(this.category, this.artist)
					// this.getPageCount()
					// this.setPaging()
					// this.reInit()
				}
			})
			.catch(() => {
				window.location.href="/error/error.html"
			})
		},
		// next() {
		// 	this.$refs.slick.next();
		// },
		// prev() {
		// 	this.$refs.slick.prev();
		// },
		// reInit() {
		// 	this.$refs.slick.destroy();
		// 	this.$nextTick(() => {
		// 		this.$refs.slick.create();
		// 	});
		// },
		toDetail(item){
			this.tagMove({path:'/products/detail/'+item, params:{'hin':item}})
			// this.$router.push({path:'/products/detail/'+item, params:{'hin':item}})
		},
		chkPath(){
			if(this.path==='/'){
				this.isTop = true
				this.isProduct = false
				this.perPage = 6
			}else{
				this.isTop = false
				this.isProduct = true
				this.perPage = 12
			}
		},
		getCategory(){
			if (this.query.cat !== void 0 && this.query.artist !== void 0) {
				this.category = this.query.cat
				this.$store.commit('CHANGE_CATEGORY',this.category)
				this.artist = this.query.artist
				this.$store.commit('CHANGE_ARTISTS',this.artist)
			}else if(this.query.cat !== void 0 && this.query.artist === void 0) {
				this.category = this.query.cat
				this.$store.commit('CHANGE_CATEGORY',this.category)
				this.artist = this.$store.getters.get_artists
			}else if(this.query.artist !== void 0 && this.query.cat === void 0) {
				this.artist = this.query.artist
				this.$store.commit('CHANGE_ARTISTS',this.artist)
				this.category = this.$store.getters.get_category
			}else {
				this.category = this.$store.getters.get_category
				this.artist = this.$store.getters.get_artists
			}
		},
		sortOption(){
			let dnum=0;
			this.disList.splice(-this.disList.length);
			if (this.category !== '0' && this.artist !== '0') {
				for (let i=0; i<this.pList.length; i++) {
					for(let j=0; j<this.pList[i].category_list.length; j++) {
						let p = this.pList[i].category_list[j].category_classname
						if (this.category==p) {
							for(let k=0; k<this.pList[i].artistscategory_list.length; k++) {
								let q = this.pList[i].artistscategory_list[k].category_classname
								if(this.artist == q) {
									this.disList.splice(dnum,1,this.pList[i]);
									dnum++;
								}
							}
						}
					}
				}
			}else if(this.category !== '0' && this.artist == '0') {
				for (let i=0; i<this.pList.length; i++) {
					for(let j=0; j<this.pList[i].category_list.length; j++) {
						let p = this.pList[i].category_list[j].category_classname
						if (this.category==p) {
							this.disList.splice(dnum,1,this.pList[i]);
							dnum++;
						}
					}
				}
			}else if(this.category == '0' && this.artist !== '0') {
				for (let i=0; i<this.pList.length; i++) {
					for(let j=0; j<this.pList[i].artistscategory_list.length; j++) {
						let q = this.pList[i].artistscategory_list[j].category_classname
						if(this.artist == q) {
							this.disList.splice(dnum,1,this.pList[i]);
							dnum++;
						}
					}
				}
			}else{
				for (let i=0; i<this.pList.length; i++) {
					this.disList.splice(i,0,this.pList[i])
				}
			}
			this.$store.commit('CHANGE_CATEGORY',this.category)
			this.$store.commit('CHANGE_ARTISTS',this.artist)
			this.getPageCount()
			this.setPaging()
			this.fadeapp=true
		},
		setPaging(){
			this.num = this.$route.params['num']
			if(isNaN(this.num)){
				this.num = this.$store.getters.get_pnum
			}
			if(this.num <= this.lastPage){
				this.$store.commit('PAGE_MOVE',this.num)
				this.minSlice = (this.num-1)*this.perPage;
				this.curPage = this.num;
			}else{
				this.minSlice = 0;
				this.curPage = 1;
				this.$store.commit('PAGE_MOVE',this.curPage)
				window.history.pushState(null,null,'/products/');
			}
		},
		pageClick(page){
			// this.fadeapp=false
			this.selectPage = page
			// scrollTo(0,0)
			this.fadeContents()
			// setTimeout(this.fadeContents,300)
		},
		fadeContents(){
			if(this.selectPage<this.curPage){
				this.curPage=this.curPage-1;
				this.minSlice = (this.selectPage-1)*this.perPage;
			}else if(this.selectPage>this.curPage){
				this.curPage=this.curPage+1;
				this.minSlice = (this.selectPage-1)*this.perPage;
			}
			this.curPage = Number(this.selectPage);
			this.$store.commit('PAGE_MOVE',this.curPage)
			this.tagMove({path:'/products/'+this.selectPage, params:{}})
			// setTimeout(this.fadeapp=true,500)
		},
		preClick(){
			if(!(Number(this.curPage)<=1)){
				this.pageClick(Number(Number(this.curPage))-1);
			}
		},
		nextClick(){
			if(Number(this.curPage)!==this.lastPage){
				this.pageClick(Number(Number(this.curPage))+1);
			}
		},
		activeNum(page){
			if (Number(this.curPage)==1) {
				this.isFirst = true
				this.isLast = false
			}else if(Number(this.curPage)==this.lastPage){
				this.isLast = true
				this.isFirst = false
			}else{
				this.isFirst = false
				this.isLast = false
			}
			if(page==Number(this.curPage)){
				return 'active';
			}
		},
		getPageCount(){
			this.lastPage = Math.ceil(this.disList.length / this.perPage);
			if(this.lastPage<=1){
				this.isVisible=false;
			}else{
				this.isVisible=true;
			}
		},
		pagemove(){
			this.fadeapp=false;
			if(this.$route.params['num']!=1){
				this.$router.push('/products/1')
			}
			this.$store.commit('PAGE_MOVE',1)
			this.curPage=1
			setTimeout(this.sortOption,300);
		},
		mediaChk(status){
			if(status == 'tile'){
				if(this.media <= 480){
					return 'col-6'
				}else if(this.media <= 1024){
					return 'col-4'
				}else{
					return 'col-3'
				}
			}else if(status == 'pad'){
				if(this.media >= 768){
					return 'pl-4'
				}
			}
		},
		judgeStatus(status, variation, release){
			if(this.nowDay.length==1){
				this.nowDay = '0'+this.nowDay
			}
			if(this.nowMonth.length==1){
				this.nowMonth = '0'+this.nowMonth
			}
			let now = String(this.nowYear)+String(this.nowMonth)+String(this.nowDay)
			let vstock = []
			let cnt=0
			if(release > now){
				return 'reserve'
			}
			else if(status == 'NONE' && variation.length >= 1){
				for(var i=0; i<variation.length; i++){
					vstock[i] = variation[i].variation_stockstatus
					if(vstock[i] == 'exist'){
						cnt++
					}
				}
				if(cnt == 0){
					return 'soldout'
				}else{
					return 'exist'
				}
			}else if(status == 'SOLDOUT'){
				return 'soldout'
			}else{
				return 'exist'
			}
		},
		tagMove(to){
			// this.$gtag.query('config', process.env.VUE_APP_UA, {'page_path': to.path});
			// this.$gtag.query('config', process.env.VUE_APP_GA, {'page_path': to.path});
			this.$router.push({'path':to.path, 'params':to.params})
		},
	},
	filters: {
		addcomma: function (value) {
			if (!value) return ''
			return value.toString().replace(/(\d)(?=(\d{3})+$)/g , '$1,')
		},
	},
}
</script>